module.exports = __webpack_public_path__ + "assets/4ef80ee74467e0297eec3cc03092da01.js";